export default "__VITE_ASSET__CAusoQdU__"